import {
  ListItemSecondaryAction,
  ListItemText,
  ListItem as MuiListItem,
  Switch,
} from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { toggleSubmissionsView } from '../../../../../../store/actions';
import { selectGrowthbook } from '../../../../../../store/selectors/ui-settings.selectors';
import { withShowable } from '../../../../../_global/lib/withShowable';

const ListItem = withShowable(MuiListItem);

export const SubmissionsViewToggleListItem = () => {
  const dispatch = useDispatch();
  const { submissions_view } = useSelector(selectGrowthbook);

  function handleSubmissionsViewToggle() {
    dispatch(toggleSubmissionsView());
  }

  return (
    <ListItem>
        <ListItemText
          primary={
            <span
              className="contrast-text"
              style={{ textTransform: 'capitalize' }}
            >
              Submissions View
            </span>
          }
          disableTypography
        />
        <ListItemSecondaryAction
          onClick={handleSubmissionsViewToggle}
          style={{ right: 0 }}
        >
          <Switch value={submissions_view} checked={submissions_view} />
        </ListItemSecondaryAction>
      </ListItem>
  );
};
